import { useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/landing/shared";
import { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full rounded-xl border border-white/10 bg-[#0A0B0D] px-4 py-3.5 text-sm text-white placeholder-zinc-500 outline-none transition-colors focus:border-[#FFB800]";

  return (
    <div className="hero-grid flex min-h-screen items-center justify-center bg-[#0A0B0D] px-5" data-testid="admin-login-page">
      <div className="pointer-events-none absolute left-1/2 top-1/4 h-[380px] w-[380px] -translate-x-1/2 rounded-full bg-[#FFB800]/10 blur-[130px]" />
      <form
        onSubmit={submit}
        data-testid="admin-login-form"
        className="relative w-full max-w-md rounded-3xl border border-white/10 bg-[#11141A] p-9 shadow-2xl"
      >
        <div className="mb-8 flex flex-col items-center gap-5 text-center">
          <Logo />
          <div>
            <h1 className="flex items-center justify-center gap-2 font-display text-2xl font-bold uppercase text-white">
              <Lock size={18} className="text-[#FFB800]" /> Painel Administrativo
            </h1>
            <p className="mt-1 text-sm text-zinc-500">Acesso restrito — Manutentudo Serviços</p>
          </div>
        </div>
        {error && (
          <div data-testid="admin-login-error" className="mb-4 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-400">
            {error}
          </div>
        )}
        <div className="space-y-4">
          <input
            type="email"
            required
            data-testid="admin-email-input"
            placeholder="E-mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={inputCls}
          />
          <input
            type="password"
            required
            data-testid="admin-password-input"
            placeholder="Senha"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={inputCls}
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-[#FFB800] py-4 font-display text-base font-bold uppercase tracking-wider text-black transition-transform hover:scale-[1.02] disabled:opacity-60"
          >
            {loading && <Loader2 size={18} className="animate-spin" />}
            {loading ? "Entrando..." : "Entrar no Painel"}
          </button>
        </div>
      </form>
    </div>
  );
}
